const getBannerStyles = () => `<style>
    .gdpr-consent-banner {
      transition: all 250ms ease-out;
      opacity: 1;
    }
    .gdpr-consent-banner--fade-out {
      opacity: 0;
    }
    .gdpr-consent-banner a {
      text-decoration: underline;
      font-size: 16px;
      line-height: 22px;
    }
    .gdpr-consent-modal-overlay {
      position: fixed;
      box-sizing: border-box;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      width: 100vw;
      height: 100vh;            /* fall-back */
      height: -moz-available;
      height: -webkit-fill-available;
      height: fill-available;
      background: rgba(0,0,0,0.6);
      z-index: 3000080;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .gdpr-consent-modal-overlay * {
      box-sizing: border-box;
    }
    .gdpr-consent-modal-header {
      border-bottom: 1px solid #E5E5E4;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 0;
    }
    .gdpr-consent-modal-tenant-logo.hz-SvgAsset {
      height: 24px;
      display: inline-block;
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
    .gdpr-consent-modal {
      width: 100%;
      height: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
    }
    .gdpr-consent-modal-content {
      padding: 0 16px 32px 16px;
      overflow-y: auto;
      color: #2D3C4D;
    }
    .gdpr-consent-modal-content-header {
      margin: 24px 0 16px 0;
    }
    .gdpr-consent-modal-content-body {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
    }
    .gdpr-consent-modal-content-body-desktop-text {
      display: none;
    }
    .gdpr-consent-modal-footer {
      display: flex;
      flex-direction: column;
      border-top: 1px solid #E5E5E4;
      padding: 12px 16px 0 16px;
      margin-top: auto;
      gap: 12px;
      margin-bottom: 12px;
    }
    @media all and (min-width: 767px) {
      .gdpr-consent-modal {
        max-width: 700px;
        height: auto;
        border-radius: 4px;
      }
      .gdpr-consent-modal-footer {
        justify-content: end;
        flex-direction: row-reverse;
      }
      .gdpr-consent-modal-content-body-mobile-text {
        display: none;
      }
      .gdpr-consent-modal-content-body-desktop-text {
        display: inline;
      }
    }
</style>`;

export default getBannerStyles;
